export function changeEnvFavicon(domain = '') {
  domain = window.location.href;

  let color = '';
  const favicon = document.getElementById('favicon');
  const match = domain.match(/\.(sandbox|acceptance|integration)\./);
  const colors = {
    sandbox:      '-sandbox',
    acceptance:   '-acceptance',
    integration:  '-integration'
  };

  if (match) {
    color = colors[match[1]];
  }

  if (favicon) {
    favicon.setAttribute('href', '/assets/favicon' + color + '.ico');
  }
}
